import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, Grid, Typography, DialogActions, Button } from '@material-ui/core';
import { Elements, CardElement, injectStripe, ReactStripeElements } from 'react-stripe-elements';

import PaymentMethod from '../../entities/PaymentMethod';
import { AccountService } from '../../services/AccountService';

interface Props extends ReactStripeElements.InjectedStripeProps {
    onClose: () => void;
    isOpen: boolean;
    onSuccess: (paymentMethod: PaymentMethod) => void;
}

function ChangeCardDialogComponent(props:Props) {
    const [disabled, setDisabled] = useState(false);
    const [validationError, setValidationError] = useState("")

    const onClose = () => {
        if (disabled)
            return;

        props.onClose();
    }

    const onSubmitPayment = async(e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (disabled)
            return;

        setDisabled(true);
        const {token, error} = await props.stripe!.createToken();
        setDisabled(false);

        if (error) return setValidationError(error.message ?? "Something went wrong, please try again or contact customer support");
        if(token){
            setDisabled(true);
            const paymentMethodResponse = await AccountService.changePaymentMethod(token.id);
            setDisabled(false);

            if(paymentMethodResponse.success) return props.onSuccess(paymentMethodResponse.data);
            if(paymentMethodResponse.error) return setValidationError(paymentMethodResponse.message);
            setValidationError(paymentMethodResponse.errors[0].errors[0]);
        }
    }

    return (
        <Dialog open={props.isOpen} onClose={onClose}>
            <DialogTitle>
                Change Your Sermon Maker Payment Method
            </DialogTitle>
            <form autoComplete="off" onSubmit={(e) => onSubmitPayment(e)}>
                <DialogContent>
                    <Grid container>
                        <Grid item xs={12}>
                            <CardElement/>
                            <Typography dangerouslySetInnerHTML={{__html: validationError || "" }} />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={onClose} disabled={disabled}>
                        Cancel
                    </Button>
                    <Button color="primary" type="submit" disabled={disabled}>
                        Change Payment
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}

const ChangeCardDialogWithStripe = injectStripe(ChangeCardDialogComponent);

export function ChangeCardDialog(props:Props){
    return (
        <Elements>
            <ChangeCardDialogWithStripe {...props} />
        </Elements>
    );
}